import { render, staticRenderFns } from "./PapersShow.vue?vue&type=template&id=17c91356&scoped=true"
import script from "./PapersShow.vue?vue&type=script&lang=js"
export * from "./PapersShow.vue?vue&type=script&lang=js"
import style0 from "./PapersShow.vue?vue&type=style&index=0&id=17c91356&prod&lang=less&scoped=true"
import style1 from "./PapersShow.vue?vue&type=style&index=1&id=17c91356&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c91356",
  null
  
)

export default component.exports